import React, { useContext } from "react";
import Layout from "../../components/global/Layout";
import { Container, Row, Col } from "react-bootstrap";
import { _rest, } from '../../services/api';
import { IMGS } from "../../theme";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddFacePhoto from "./addFacePhoto";
import { Image } from 'antd';
import SkeletonLoader from '../../components/global/SkeletonLoader'
import DeleteLoader from '../../components/global/DeleteLoader'
import { AuthContext } from "../../context";
import { Modal } from 'antd';


function FaceGallery() {
   const { user, logout } = useContext(AuthContext);
   const [isLoading, setLoading] = React.useState(false);
   const [isDeleting, setIsDeleting] = React.useState(false);
   const [deletingIndex, setDeletingIndex] = React.useState(null);

   const [faceImages, setFaceImages] = React.useState([]);
   React.useEffect(() => { fetchUserFacePhotos() }, [])

   const fetchUserFacePhotos = async () => {
      setLoading(true);
      try {
         const res = await _rest.fetchUserFacePhotos(user?.user_id);
         if (res?.success) {
            setFaceImages(res['data']);
            if (res['data'].length < 5) {
               countDown();
            }
         }
      } catch (error) {
         if (error.status === 401) {
            logout();
         }
      }
      setLoading(false);
   };


   const newFacePhoto = async (data) => {
      let faceImagesArr = [data, ...faceImages];
      setFaceImages(faceImagesArr)
   };

   const deleteFaceImg = async (item, i) => {
      setIsDeleting(true);
      setDeletingIndex(i)
      const res = await _rest.deleteUserFacePhoto({ photoPublicID: item.photoPublicID, user_id: user.user_id });
      setIsDeleting(false);
      if (res?.success) {
         let faceImagesArr = faceImages.filter((obj) => { return obj?.photoPublicID !== res?.data?.photoPublicID });
         setFaceImages(faceImagesArr)
      }
   };


   const [modal, contextHolder] = Modal.useModal();
   const countDown = () => {
      let secondsToGo = 5;
      const instance = modal.warning({
         title: 'Please note!!',
         content: `Upload atleast 5 face images for better face detection while scanning.`,
         centered: true,
         wrapClassName: 'warning-pop-up'
      });
      setTimeout(() => { instance.destroy(); }, secondsToGo * 1000);
   };

   return (
      <Layout styleId="face-gallery-root">
         <Container >
            <section id="user-face-pic-list">
               <div className="list-header">
                  <h6>Uploaded Faces: {faceImages.length}/5</h6>
                  {faceImages?.length < 5 &&
                     <AddFacePhoto newFacePhoto={newFacePhoto} user={user} logout={logout} />
                  }
               </div>
               <Row style={{ justifyContent: 'center', alignItems: 'center' }} className="pic-listing-row">
                  {isLoading ? (
                     [0, 0, 0, 0, 0, 0, 0, 0].map((item, i) => (
                        <Col md={3} key={i} className="pic-card-grid">
                           <SkeletonLoader />
                        </Col>
                     ))
                  ) :
                     (
                        faceImages?.length === 0 ? (
                           <div className="no-face-data">
                              <div className="center">
                                 <h5>No face image found</h5>
                                 <h6>Please upload minimum 5 face images <br />for better face recognition  while scanning.</h6>
                              </div>
                           </div>
                        ) :
                           faceImages?.map((item, i) => (
                              <Col md={3} key={i} className="pic-card-grid">
                                 <div className="picture-card">
                                    <div className="face-img">
                                       <Image
                                          src={item.photoURL}
                                          alt={"Face Photo: " + i}
                                          preview={(isDeleting && deletingIndex === i) ? false : true}
                                          fallback={IMGS.placeholder}
                                          className={isDeleting && deletingIndex === i ? 'disabled' : ''}
                                       />
                                       {isDeleting && deletingIndex === i ? <DeleteLoader /> : ''}

                                       <IconButton aria-label="delete" onClick={() => deleteFaceImg(item, i)} disabled={isDeleting}>
                                          <DeleteIcon fontSize="small" />
                                       </IconButton>
                                    </div>
                                 </div>
                              </Col>
                           ))
                     )
                  }
               </Row>
            </section>
            {contextHolder}
         </Container>
      </Layout >
   );
}

export default FaceGallery;
